export const environment = {
  production: true,
  apiUrl: 'https://riskadmin.cercatoeassociati.com/api',
  airbrakeProjectKey: 'ad437d53c022838342426a6645dda4b6',
  errorsUrl: 'https://errors.moku.io'
};

